import { render } from "./DeleteProjectDialog.vue?vue&type=template&id=066fd038"
import script from "./DeleteProjectDialog.vue?vue&type=script&lang=js"
export * from "./DeleteProjectDialog.vue?vue&type=script&lang=js"

import "./DeleteProjectDialog.vue?vue&type=style&index=0&id=066fd038&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__